<template>
  <div>
    <!-- modal -->
    <b-modal
      id="permissionFormModal"
      centered
      size="lg"
      no-close-on-backdrop
      ref="permissionFormModal"
      :title=" $t('permission.info')"
      :cancel-title=" $t('others.cancel_title')"
      :ok-title=" $t('others.ok_title')"
      cancel-variant="outline-secondary"
      @close="clear()"
      @ok.prevent="addOrUpdate"
    >
    <validation-observer ref="simpleRules">
        <b-form>
          <b-row>
            <b-col>
            <validation-provider
              :name=" $t('permission.group_name')"
              :rules="{ excluded:0}" 
              v-slot="{ errors }"
            >
            <label for="permission-name-input">{{ $t('permission.group_name') }}</label>
            <b-form-group>
              <b-form-select
                size="sm"
                :state="errors.length > 0 ? false:null"
                v-model="permissionGroupSelect"
                value-field="id"
                text-field="name"
                :options="permissionGroupOption"
              />
            <small class="text-danger">{{ errors[0] }}</small>   
            </b-form-group>
            </validation-provider>
            <validation-provider
              #default="{ errors }"
              :name=" $t('permission.name')"
              rules="required"
            >
            <label for="permission-name-input">{{ $t('permission.name') }}</label>
            <b-form-group>
              <b-form-input
                size="sm"
                id="permission-name-input"
                v-model="permissionName"
                maxlength="50"
                :state="errors.length > 0 ? false:null"
              />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
        </b-form>
    </validation-observer>
    </b-modal>
  </div>
</template>
<script>
export default {
  props: {
    getPermissionList: {type: Function}
  },
  data() {
    return {
      id: 0,
      permissionGroupSelect: 0,
      permissionGroupOption: [],
      permissionName: '',
    }
  },
  methods: {
    clear() {
      this.permissionGroupSelect = 0  
    },
    showInfo(id) {
      this.$refs['permissionFormModal'].show()
      this.id = id
      const data = {id: this.id}
      const controller = {name : 'Permission'}
      const payload = {data: data, controller: controller}
      this.$store.dispatch('moduleAuth/getInfo', payload).then((response) => {
          if(response.data.resultStatus == true){
              this.permissionName = response.data.permission.name
              this.permissionGroupOption = response.data.permissionGroupList
              this.permissionGroupSelect = response.data.permission.permissionGroupId
              this.permissionGroupOption.splice(0, 0, this.$nullSelected())
          } else {
              this.$bvModal.hide('permissionFormModal')
              this.$WarningAlert(response.data.resultMessage)
          }  
      })  
    },
    addOrUpdate() {
      const data = {id: this.id, name: this.permissionName, permissionGroupId: this.permissionGroupSelect}
      const controller = {name : 'Permission'}
      const payload = {data: data, controller: controller}
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
              this.$store.dispatch('moduleAuth/save',payload).then((response) => {
                if(response.data.resultStatus == true){
                  this.$bvModal.hide('permissionFormModal')
                  this.getPermissionList()
                  this.$SaveAlert()
                } else {
                  this.$WarningAlert(response.data.resultMessage)
                }
            })
        }
      })
    },
  }
}
</script>
<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}
[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}
.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}
[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem!important;
    margin-top: -1.5rem!important;
    background-color: #ea5455!important;
    border-radius: 0.358rem!important;
    left: 20px!important
}
</style>
